import { render, staticRenderFns } from "./LevelReviewParticipant.vue?vue&type=template&id=6c8666a8&"
import script from "./LevelReviewParticipant.vue?vue&type=script&lang=ts&"
export * from "./LevelReviewParticipant.vue?vue&type=script&lang=ts&"
import style0 from "./LevelReviewParticipant.vue?vue&type=style&index=0&id=6c8666a8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports